export const BASE_URL='https://api.entehope.xyz/api'
